import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_GATEWAY_URL,
  prepareHeaders: (headers, { getState }) => {
    return headers;
  },
});
